import { useQuery } from "@apollo/client";

import {
  ClientPackageDocument,
  PackageRecurrenceEnum,
  PackageStatusEnum,
} from "../../__generated__/graphql";

export function useClientPackage(packageId: string) {
  const { data, loading, error, refetch } = useQuery(ClientPackageDocument, {
    skip: !packageId,
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    variables: { id: packageId },
  });

  const packageDetail = data?.package ?? null;

  return {
    packageDetail,
    isActive: packageDetail?.status === PackageStatusEnum.Active,
    isAdHoc: packageDetail?.repeatEvery === PackageRecurrenceEnum.AdHoc,
    loading,
    error,
    refetch,
  };
}
